<template>
  <div id="cid-res-app-wrap" ref="refmainapp">
    <router-view 
      v-bind:input-firebase-user="firebaseDB_User"
      v-bind:input-list-of-regular-guests="firebaseDB_RegularGuests"
      v-bind:input-list-of-venue-types="firebaseDB_VenueTypes"
      v-bind:input-list-of-currency-units="firebaseDB_CurrencyTypes"      
      v-bind:input-list-of-waiters="firebaseDB_Waiters"   
      v-bind:input-table-status-enums="tableStatusEnums"    
    ></router-view>
    <!-- Offcanvas Navigation Menu -->
    <transition name="offcanvas-fade" mode="out-in">
      <offcanvas-nav v-if="offcanvasVisible==true" v-bind:input-firebase-user="firebaseDB_User"></offcanvas-nav>
    </transition>    
  </div>
</template>

<script>
import Vue from 'vue'
import EventBus from '@/EventBus'
import OffcanvasNav from '@/components/offcanvas/OffcanvasNav'
import Firebase from 'firebase'
import {firebaseDB} from '@/firebase'
import moment from "moment";
import MixinAccessChecker from '@/components/helpers/MixinAccessChecker'
Vue.mixin(MixinAccessChecker); 
export default {
  name: 'cid-res-app-wrap',
  components: {
    OffcanvasNav: OffcanvasNav
  },
  /* Since our user logged in, we can now get generally used data with VueFire
  */
  firebase: function () {
    return {
      listOfAllRegularGuests: {
        source: firebaseDB.ref('listOfRegularGuests'),
        asObject: true,
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          dataSnapshot.forEach(function(dataSnapshot) {
              var item = dataSnapshot.val();
              item.key = dataSnapshot.key;
              this.firebaseDB_RegularGuests[item.key] = item;
          }.bind(this));
          //console.log('firebaseDB_VenueTypes ready: ' + JSON.stringify(this.firebaseDB_VenueTypes, null, 2));
          this.firebaseDB_RegularGuests_ready = true;
        }.bind(this)
      },      
      listOfAllVenues: {
        source: firebaseDB.ref('listOfVenues'),
        asObject: true,
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          dataSnapshot.forEach(function(dataSnapshot) {
              var item = dataSnapshot.val();
              item.key = dataSnapshot.key;
              this.firebaseDB_VenueTypes[item.key] = item;
          }.bind(this));
          //console.log('firebaseDB_VenueTypes ready: ' + JSON.stringify(this.firebaseDB_VenueTypes, null, 2));
          this.firebaseDB_VenueTypes_ready = true;
        }.bind(this)
      },
      listOfAllCurrencies: {
        source: firebaseDB.ref('listOfCurrencyUnits'),
        asObject: true,
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          dataSnapshot.forEach(function(dataSnapshot) {
              var item = dataSnapshot.val();
              item.key = dataSnapshot.key;
              this.firebaseDB_CurrencyTypes[item.key] = item;
          }.bind(this));
          //console.log('firebaseDB_CurrencyTypes ready: ' + JSON.stringify(this.firebaseDB_CurrencyTypes, null, 2));
          this.firebaseDB_CurrencyTypes_ready = true;
        }.bind(this)
      },
      listOfAllWaiters: {
        source: firebaseDB.ref('listOfWaiters'),
        asObject: true,
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          dataSnapshot.forEach(function(dataSnapshot) {
              var item = dataSnapshot.val();
              item.key = dataSnapshot.key;
              this.firebaseDB_Waiters[item.key] = item;
          }.bind(this));
          //console.log('firebaseDB_CurrencyTypes ready: ' + JSON.stringify(this.firebaseDB_CurrencyTypes, null, 2));
          this.firebaseDB_Waiters_ready = true;
        }.bind(this)
      },
      listOfAppAccessLevels: {
        source: firebaseDB.ref('listOfAppAccessLevels'),
        asObject: true,
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          dataSnapshot.forEach(function(dataSnapshot) {
              var item = dataSnapshot.val();
              item.key = dataSnapshot.key;
              this.firebaseDB_AccessLevels[item.key] = item;
          }.bind(this));
          //console.log('firebaseDB_CurrencyTypes ready: ' + JSON.stringify(this.firebaseDB_CurrencyTypes, null, 2));
          this.firebaseDB_AccessLevels_ready = true;
        }.bind(this)
      },      
    }
  },
  data () {
    return {
      testMsg: 'MainApp-file-right-here',
      // Offcanvas menu visibility (on/off)
      offcanvasVisible: false,
      // status rezervacije (1=Ceka se gost da dodje, 2=Gost je dosao, 3=Gost nije dosao), koristi se da se zna da li je gost dosao ili je ispalio
      tableStatusEnums: {
        waiting: 1,
        arrived: 2,
        notArrived: 3
      },      
      // Firebase User/Admin info
      firebaseDB_User: {
        // Firebase account
        currentUser: null,
        // User specific details (first name, last name, phone..)
        userDetails: null,
        isOnline: false
      },
      // ~ List of all Regular Guests
      firebaseDB_RegularGuests: {},
      firebaseDB_RegularGuests_ready: false,      
      // ~ List of all Venues types
      firebaseDB_VenueTypes: {},
      firebaseDB_VenueTypes_ready: false,
      // ~ List of all Currency types
      firebaseDB_CurrencyTypes: {},
      firebaseDB_CurrencyTypes_ready: false,
      // ~ List of all Waiters
      firebaseDB_Waiters: {},
      firebaseDB_Waiters_ready: false,
      // ~ List of all Access Levels that user could be (Admin role, Manager role, Hostess role..)
      firebaseDB_AccessLevels: {},
      firebaseDB_AccessLevels_ready: false        
    }
  },
  methods: {
    toggleOffcanvas: function () {
      this.offcanvasVisible = !this.offcanvasVisible
    },
    // This function will be called to check if everything is ready to show first view AFTER ALL REQUIRED DATA IS GATHERED
    checkIfEverythingIsReadyForFirstView: function () {
      if (this.firebaseDB_AccessLevels_ready === true && this.firebaseDB_RegularGuests_ready === true && this.firebaseDB_VenueTypes_ready === true && this.firebaseDB_CurrencyTypes_ready === true && this.firebaseDB_Waiters_ready === true){
        // ~ Check if all required data are gathered
        this.$router.replace('future-events');
      }else{
        setTimeout(function(){ this.checkIfEverythingIsReadyForFirstView(); }.bind(this), 300);
      }      
    }
  },
  created: function () {
    console.log('||-created: MainApp');
    /* 
      #region Auto Sign in after Refresh (page reload)
    */    
    if (this.firebaseDB_User && !this.firebaseDB_User.currentUser){
      // !!!-IMPORTANT - When user refresh some page, this condition will be triggered and we will AUTO SIGN IN our user
      //this.checkIfEverythingIsReadyForFirstView();
      this.$router.replace('gather-user-info');
    }
    /* 
      #endregion Auto Sign in after Refresh (page reload)
    */
    /* 
      #region Gather User data after login
    */
    EventBus.$on('event_userDataGathered', function (inputUserData) {
      // !!!-IMPORTANT - If user LOGS IN (must be logged out), Firebase user info will be gathered inside 'GatherUserInfo.vue' and then passed in this event
      this.firebaseDB_User = inputUserData;
      //this.glMixin_updateFirebaseUserData(this.firebaseDB_User);
      //console.log('event_userDataGathered in MainApp, this.firebaseDB_User: ' + JSON.stringify(this.firebaseDB_User, null, 2));
      this.checkIfEverythingIsReadyForFirstView();
      //this.$router.replace('future-events');
    }.bind(this));
    /*
      #endregion Gather User data after login
    */     
    /* 
      #region Toggle Visibility of Offcanvas menu 
    */
    EventBus.$on('toggleOffcanvas', function () {
      this.toggleOffcanvas()
    }.bind(this));
    EventBus.$on('closeToggleOffcanvas', function () {
      this.offcanvasVisible = false;
    }.bind(this));
    /* 
      #endregion Toggle Visibility of Offcanvas menu 
    */
    // Access Level method that will return true or false depending on admin/user role leve
    // Vue.glMethod_userAccessCheck = function (inputUserAccessRoleKey, inputConditionLevel) {
    //   var returnState = false;
    //   if (inputUserAccessRoleKey && inputConditionLevel && inputUserAccessRoleKey >= inputConditionLevel){
    //     returnState = true;
    //   }
    //   return returnState;
    // }
    // Vue.mixin({
    //   methods: {
    //     glMethod_userAccessCheck: function (inputUserAccessRoleKey, inputConditionLevel){
    //       var returnState = false;
    //       if (inputUserAccessRoleKey && inputConditionLevel && inputUserAccessRoleKey >= inputConditionLevel){
    //         returnState = true;
    //       }
    //       return returnState;
    //     }
    //   }
    // })    
    // Vue.filter('glFilter_userAccessCheck', function (inputUserAccessRoleKey, inputConditionLevel) {
    //   var returnState = false;
    //   if (inputUserAccessRoleKey && inputConditionLevel && inputUserAccessRoleKey >= inputConditionLevel){
    //     returnState = true;
    //   }
    //   // if (this.firebaseDB_AccessLevels && inputUserAccessRoleKey) {
    //   //   for (var key in this.firebaseDB_AccessLevels) {
    //   //     if (this.firebaseDB_AccessLevels.hasOwnProperty(key) && key == inputUserAccessRoleKey) {
    //   //       returnState = true;
    //   //       break;
    //   //     }
    //   //   }
    //   // }      
    //   return returnState;
    // });        
    /* 
      !!!-IMPORTANT - In here we will create GLOBAL FILTERS
    */ 
    // Test Filter to check if filter is available inside some component   
    Vue.filter('testFilter', function (inputTestValue) {
        return inputTestValue.toString() + '-success_filtered';
    });
    // Filter that will return event Day & Month (31. Apr)
    Vue.filter('glFilter_returnFormatedDate', function (inputDate, inputWantedFormat) {
      var returnFormatedDate = "Unk";
      if (inputDate && inputWantedFormat) {
        var newFormat = inputWantedFormat.toString();
        returnFormatedDate = moment(inputDate).format(newFormat);
      }
      //
      return returnFormatedDate;      
    });
    // Filter that will return Currency type (RSD, EUR..)
    Vue.filter('glFilter_currency_typeName', function(inputCurrencyTypeUid){
      var returnCurrencyName = "--";
      if (this.firebaseDB_CurrencyTypes && inputCurrencyTypeUid) {
        for (var key in this.firebaseDB_CurrencyTypes) {
          if (this.firebaseDB_CurrencyTypes.hasOwnProperty(key)) {
            if ( key == inputCurrencyTypeUid && this.firebaseDB_CurrencyTypes[key].title ) {
              //console.log('name is this: ' + this.inputListOfVenueTypes[key].name);
              returnCurrencyName = this.firebaseDB_CurrencyTypes[key].title;
            }
          }
        }
      }
      return returnCurrencyName;
    }.bind(this))    
    // Filter that will return Venue type (type of reservations and their tables available for guests to reserve)
    Vue.filter('glFilter_venue_typeName', function (inputVenueTypeUid) {
      var returnVenueType = "Nedefinisan";
      if (this.firebaseDB_VenueTypes && inputVenueTypeUid) {
        for (var key in this.firebaseDB_VenueTypes) {
          if (this.firebaseDB_VenueTypes.hasOwnProperty(key)) {
            // if inputVenueTypeUid matches key (uid) && key has 'name'
            if (key == inputVenueTypeUid && this.firebaseDB_VenueTypes[key].name) {
              returnVenueType = this.firebaseDB_VenueTypes[key].name;
            }
          }
        }
      }
      return returnVenueType;  
    }.bind(this));
    // Format Number to commas
    Vue.filter('glFilter_numberToCommas', function (inputNumber) {
      var returnValue = inputNumber;
      if (inputNumber){
        returnValue = inputNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      return returnValue;
    });
    // Return Waiter name
    Vue.filter('glFilter_waiterFullName', function (inputWaiterUid) {
      var returnValue = 'Unk';
      if (inputWaiterUid && this.firebaseDB_Waiters){
        for (var key in this.firebaseDB_Waiters) {
          if (this.firebaseDB_Waiters.hasOwnProperty(key) && this.firebaseDB_Waiters[key].uid && this.firebaseDB_Waiters[key].uid == inputWaiterUid) {
            if (this.firebaseDB_Waiters[key].firstName && this.firebaseDB_Waiters[key].lastName){
              returnValue = this.firebaseDB_Waiters[key].firstName + ' ' + this.firebaseDB_Waiters[key].lastName;
            }
          }
        }
      }
      return returnValue;
    }.bind(this));
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/MainApp.vue